import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConfirmationModelComponent } from '../../components/confirmation-model/confirmation-model.component';
import { SafePipeModule } from '../safe/safe';


@NgModule({
    exports: [
        ConfirmationModelComponent
    ],
    declarations: [
        ConfirmationModelComponent
    ],
    imports: [
        CommonModule,
        SafePipeModule
    ]
})
export class ConfirmationModalModule { }
